export class HealthQuestionnaire {
    constructor(
        public OfferID?: Number,
        public Q1Answer?: Boolean,
        public Q1Description?: String,
        public Q2Answer?: Boolean,
        public Q2Description?: String,
        public Q3Answer?: Boolean,
        public Q3Description?: String,
        public Q4Answer?: Boolean,
        public Q4Description?: String,
        public Q5Answer?: Boolean,
        public Q5Description?: String,
        public Q6Answer?: Boolean,
        public Q6Description?: String,
        public Q7Answer?: Boolean,
        public Q7Description?: String,
        public Q8Answer?: Boolean,
        public Q8Description?: String,
        public Q9Answer?: Boolean,
        public Q9Description?: String,
        public Q10Answer?: Boolean,
        public Q10Description?: String,
        public Q11Answer?: Boolean,
        public Q11Description?: String,
        public Q12Answer?: Boolean,
        public Q12Description?: String,
        public Q13Answer?: Boolean,
        public Q13Description?: String,
        public Q14Answer?: Boolean,
        public Q14Description?: String,
        public Q15Answer?: Boolean,
        public Q15Description?: String,
        public Q16Answer?: Boolean,
        public Q17Answer?: Boolean,
        public Q17Description?: String,
        public Agreement?: Boolean) { }
}